export const RATING_LIST_RANGE = 100
